/**
 * 全局CDN地址，涉及到cdn域名地址的全部走这里
 */
export const CDN_BASE_URL = "https://ali-global-cdn.hellotalk8.com";

export const RETENTION_CDN_BASE_URL = `${CDN_BASE_URL}/keep_and_increase`;

/**
 * 头像域名地址
 */
export const HEAD_BASE_URL = `${CDN_BASE_URL}/`;

/**
 * 懒加载默认兜底头像
 */
export const DEFAULT_AVATAR = `${CDN_BASE_URL}/h5_common_images/avatar.png`;

/**
 * 数据上报地址
 */
export const DATA_ANALYTIC_URL = "https://ta-upload.hellotalk8.com/";

/**
 * 国旗地址url域名地址
 */
export const FLAG_BASE_URL = `${CDN_BASE_URL}/pub/flags/`;
